import React from "react";
import Layout from "../Components/Layout";
import Header from "../Components/Header";
import ONOEImage from "../Assets/Marathon/one-nation-one-election.png";
import HistoricalImage from "../Assets/Marathon/historic-movement.png";
import PriceMoneyImage from "../Assets/Marathon/price-money.png";
import BenifitImage1 from "../Assets/Marathon/benifits-1.png";
import BenifitImage2 from "../Assets/Marathon/benifits-2.png";
import { Helmet } from "react-helmet";
import Article from "../Components/Article";
import GalleryButton from "../Buttons/GalleryButton";
import CertificateButton from "../Buttons/CertificateButton";

function importAll(r) {
  return r.keys().map(r);
}

const HighLightImages = importAll(
  require.context("../Assets/HighLightImage", false, /\.(png|jpe?g|JPG|svg)$/)
);


const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>Marathon Noida | One Nation One Election</title>
        <meta
          name="description"
          content="Join the movement! #ISupport1Nation1Election – Register now and be a part of Marathon Noida."
        />
        <meta
          name="keywords"
          content="One Nation One Election, ONOE, Marathon Noida, Register, India, Movement"
        />
        <meta property="og:title" content="One Nation One Election" />
        <meta
          property="og:description"
          content="Support the historic #1Nation1Election movement. Register now for the upcoming Marathon Noida tournament!"
        />
        <meta property="og:image" content={ONOEImage} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <Layout>
        <Header heading="Prize Money Cross Country Race" />

        <div className="flex flex-col items-center justify-center py-2 px-4 text-center">
          {/* <div className="w-full max-w-2xl text-center py-4 text-lg text-orange-600 font-semibold">
          Total Registered Participants: {userCount}
        </div> */}
          <div className="w-full max-w-2xl mx-auto flex justify-center items-center gap-4 py-1 text-lg font-semibold text-orange-600">
            <span>#ISupport1Nation1Election</span>
          </div>

          {/* Gallery button */}
          <div className="flex gap-4 mb-4">
            <GalleryButton />
            <CertificateButton />
          </div>

          {/* Certificates button  */}
          {/* <div class="bottom-5 left-0 right-0 flex justify-center px-4 py-4">
            <button class="bg-[#df670e] hover:bg-orange-700 text-white px-8 py-6 rounded-full text-1xl font-medium transition-all shadow-md">
              {" "}
              Certificates will be available for download after May 4, 2025.
            </button>
          </div> */}

          {/* Banner Image */}
          <div className="max-w-2xl mb-8">
            <img
              src={ONOEImage}
              alt="One Nation One Election Banner"
              className="w-full rounded-xl shadow-lg object-cover"
            />
          </div>

          <div className="max-w-2xl mb-8">
            <img
              src={PriceMoneyImage}
              alt="One Nation One Election price maney Banner"
              className="w-full rounded-xl shadow-lg object-cover"
            />
          </div>

          {/* Introduction Text */}
          <div className="mb-8 text-gray-700 max-w-2xl">
            <img
              src={HistoricalImage}
              alt="One Nation One Election Banner"
              className="w-full rounded-xl shadow-lg object-cover"
            />
          </div>

          {/* Benefits Section */}
          <div className="text-left w-full max-w-2xl">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6">
              <img
                src={BenifitImage1}
                alt="Benefit 1"
                className="w-full rounded-xl shadow-md object-cover"
              />
              <img
                src={BenifitImage2}
                alt="Benefit 2"
                className="w-full rounded-xl shadow-md object-cover"
              />
            </div>
          </div>

          {/* Highlight Images Section */}
          <section className="w-full max-w-6xl mx-auto px-4 py-12 text-center">
            <h2 className="text-3xl font-bold text-orange-700 mb-8">
              The Visionaries of ONOE
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {HighLightImages.map((img, index) => (
                <div
                  key={index}
                  className="rounded-xl shadow-md overflow-hidden group transform hover:scale-105 transition duration-300"
                >
                  <img
                    src={img}
                    alt={`Visionary ${index + 1}`}
                    className="w-full h-64 object-cover"
                  />
                </div>
              ))}
            </div>
          </section>

          <Article />
          {/* CTA Button */}
          {/* <div className="fixed bottom-5 left-0 right-0 flex justify-center z-50">
            <RegisterButton />
          </div> */}
        </div>
      </Layout>
    </>
  );
};

export default HomePage;
